import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import reduce from 'lodash/reduce';
import camelCase from 'lodash/camelCase';
import isEmpty from 'lodash/isEmpty';
import { ui } from '@/constants';

export interface Pill {
  selected: boolean;
  highlighted: boolean;
  deselectedWhileHover: boolean;
}

export interface PillOptions {
  [key: string]: Pill;
}

@Component({ name: 'CmgPillSelector' })
export default class CmgPillSelector extends Vue {
  @Prop({ type: Object, required: false })
  initialPills?: PillOptions;

  pills: PillOptions = reduce(this.OPTIONS, (accu, option) => ({ ...accu, [camelCase(option)]: { selected: false, highlighted: false, deselectedWhileHover: false } }), {});

  mounted() {
    if (this.initialPills && !isEmpty(this.initialPills)) {
      this.pills = this.initialPills;
    }
  }

  get camelCase() {
    return camelCase;
  }

  get OPTIONS(): string[] {
    return ['Taste', 'Portion Size', 'Wrong / Missing Item(s)', 'Order Was Late', 'Something Else'];
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }

  get isDelivery(): boolean {
    return this.$services.order.isDelivery();
  }

  getFilledClass(pillName: string): string {
    const pill = this.pills[camelCase(pillName)];
    return !pill.deselectedWhileHover && (pill.highlighted || pill.selected) ? 'filled' : '';
  }

  onMouseEnter(option: string): void {
    // Prevent weird hover bug when on mobile devices
    if (!this.isMobile) {
      this.pills[camelCase(option)].highlighted = true;
    }
  }

  onMouseLeave(option: string): void {
    // Prevent weird hover bug when on mobile devices
    if (!this.isMobile) {
      const pill = this.pills[camelCase(option)];
      pill.highlighted = false;
      pill.deselectedWhileHover = false;
    }
  }

  onClickPill(option: string): void {
    const pill = this.pills[camelCase(option)];
    pill.selected = !pill.selected;
    pill.deselectedWhileHover = !pill.selected;
    this.$emit('pill-selected', this.pills);
  }
}
